import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getReport } from './../../actions/upload-actions';
import { CSVLink } from "react-csv";

function Upload(){
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);

    useEffect(() => {
        if (loadData) {
            setLoadData(false);
            setData([]);
            dispatch( getReport( getFunction, user.token ) );
        }
    }, [loadData, dispatch, user.token]);

    const getFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setData(data.data.document);
        }
    }

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Cargue masivo</h1>
                { data.length > 0 ?
                    <CSVLink 
                    filename={`casos ${new Date()}.csv`}
                    className="primary-button"
                    data={data}>Descargar</CSVLink>
                : null
                }

            </div>
        </div>
    );
}

export default Upload;
  